/* Catch Font Styles/Mobile/H2 Primary */
const textMobileH2Primary = {
  fontFamily: 'Inter',
  fontSize: '1.875rem',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '130%',
};

/* Catch Font Styles/Mobile/H2 Accent */
const textMobileH2Accent = {
  fontFamily: 'Libre Baskerville',
  fontSize: '1.875rem',
  fontStyle: 'italic',
  fontWeight: '400',
  lineHeight: '130%',
};

/* Catch Font Styles/Copy/Medium Body, Regular */
const textMediumBodyRegular = {
  fontFamily: 'Inter',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '130%',
};

/* Catch Font Styles/Mobile/H3 Primary */
const textMobileH3Primary = {
  fontFamily: 'Inter',
  fontSize: '1.375rem',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '130%',
};

/* Catch Font Styles/Copy/Medium Body, Semi Bold */
const textMediumBodySemiBold = {
  fontFamily: 'Inter',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '130%',
};

/* Catch Font Styles/Copy/Small Body, Regular */
const textSmallBodyRegular = {
  fontFamily: 'Inter',
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '130%',
};

/* Catch Font Styles/Copy/Medium Body, Bold */
const textMediumBodyBold = {
  fontFamily: 'Inter',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '130%',
};

const textBodyCopySemiBold = {
  fontFamily: 'Inter',
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '140%',
};

const styles = {
  text: {
    mobile: {
      h2: {
        primary: textMobileH2Primary,
        accent: textMobileH2Accent,
      },
      h3: textMobileH3Primary,
    },
    body: {
      regular: textMediumBodyRegular,
      semiBold: textMediumBodySemiBold,
      bold: textMediumBodyBold,
      small: textSmallBodyRegular,
      copySemiBold: textBodyCopySemiBold,
    },
  },
};

export const text = styles.text;
